export class AccountInfoModel {
  FullName: string;
  MobileNumber: number;
  EmailAddress: string;
  TotalNoOfcards: number;
  CCMSBalance: number;
  CardBalance: number;
  TotalBalance: number;
  AssociatedCards: AccountInfoModelList[];
}
export class AccountInfoModelList {
  FullName: string;
  CardNumber: string;
  CardBalance: number;
  MappedVechile: number;
  IsActive: boolean;
  StatusTypeId: number;
  DailyLimit: number;
  MonthlyLimit: number;
  TransactionLimit: number;
  CCMSDailyLimit: number;
  CCMSMonthlyLimit: number;
  CCMSTransactionLimit: number;
  CardId: number;
  PartnerId: number;
  PartnerName: string;
}



// WEBPACK FOOTER //
// ./src/app/models/account-info/myAccountInfoModel.ts